<template>
  <div class="conPay">
    <div class="mainArea">
      <div class="title">扫码支付</div>
      <div class="payCode">
        <div class="initCodeStyle" v-if="!payUrl">
          <div class="loader"></div>
        </div>
        <t-qrcode
          v-if="payUrl"
          :value="payUrl"
          :icon="require('@/assets/images/boluoCen.png')"
          borderless
          bgColor="#f7f7f7"
          :size="240"
          :iconSize="56"
          class="qrPos"
        />
        <svg-icon
          icon-class="close"
          class="close"
          @click="closeDialog"
        ></svg-icon>
      </div>
      <div class="useWx">
        使用 <svg-icon icon-class="wx" class="wxCode" /> 微信扫码支付
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import {
  getLessionsDetail,
  getAudiobookDetail,
  createOrder,
  wechatAppletPay,
  getOrderDetail
} from "@/api/publicApi";

export default {
  props: {
    payType: {
      type: Number,
      default: 0
    },
    lessionOrAudioBookId: {
      type: Number,
      default: 0
    }
  },
  components: {},

  data() {
    return {
      isQRCodeGenerated: false,
      payUrl: "", // 用于存储支付链接
      orderNo: "", // 订单号
      orderInfoTimer: null, // 添加定时器引用
      lastTimer: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions(["closePayDialog", "refreshBasicInfo"]),

    closeDialog() {
      this.closePayDialog();
      clearInterval(this.orderInfoTimer);
      this.orderInfoTimer = null;
    },

    initData() {
      // type: 0, //type - 资源类型 (1=有声书, 2=课程)
      let type = this.payType;
      let id = this.lessionOrAudioBookId;

      if (type == 2) {
        getLessionsDetail({
          id: id
        }).then(res => {
          if (!res.code) {
            this.info = res.data.lession;

            const data = {
              goodsId: this.info.id,
              goodsNo: this.info.goodsNo,
              goodsName: this.info.title,
              orderAmount: this.info.price,
              goodsType: 6
            };

            this.createOrderInfo(data);
          } else {
            // this.$message.warning("未获取课程信息，返回首页");
            // this.$router.push("/");
          }
        });
      } else if (type == 1) {
        getAudiobookDetail({
          id: id
        }).then(res => {
          if (!res.code) {
            this.info = res.data.audiobook;

            const data = {
              goodsId: this.info.id,
              goodsNo: this.info.goodsNo,
              goodsName: this.info.title,
              orderAmount: this.info.price,
              goodsType: 5
            };

            this.createOrderInfo(data);
          } else {
            // this.$message.warning("未获取有声书信息，返回首页");
            // this.$router.push("/");
          }
        });
      }
    },

    createOrderInfo(data) {
      createOrder({
        goodsId: data.goodsId,
        goodsNo: data.goodsNo,
        goodsName: data.goodsName,
        orderAmount: data.orderAmount,
        goodsType: data.goodsType
      }).then(res => {
        if (!res.code) {
          this.orderNo = res.data.orderNo;
          this.wechatPay(this.orderNo);
        } else {
          // this.$message.error(res.msg);
        }
      });
    },

    // 微信支付
    wechatPay(orderNo) {
      wechatAppletPay({
        orderNo: orderNo
      }).then(res => {
        if (!res.code) {
          // console.log("微信支付：", res.data);
          this.payUrl = res.data.payUrl;
          this.runOrder();
        } else {
          // this.$message.error(res.msg);
        }
      });
    },

    // 轮询订单支付结果
    runOrder() {
      this.lastTimer = new Date().getTime();
      this.getOrderInfo();
      if (!this.orderInfoTimer) {
        this.orderInfoTimer = setInterval(() => {
          this.getOrderInfo();
        }, 3000);
      }
    },

    getOrderInfo() {
      // OrderStatus_OrderStatusDefault   OrderStatus = 0 // 默认
      // OrderStatus_OrderStatusCreate    OrderStatus = 1 // 已下订单
      // OrderStatus_OrderStatusCancel    OrderStatus = 2 // 订单取消
      // OrderStatus_OrderStatusTimeout   OrderStatus = 3 // 订单超时关闭
      // OrderStatus_OrderStatusPartial   OrderStatus = 4 // 部分支付
      // OrderStatus_OrderStatusCompleted OrderStatus = 5 // 支付完成

      // PayStatus_PayStatusDefault       PayStatus = 0 // 默认
      // PayStatus_PayStatusWaitPay       PayStatus = 1 // 等待支付
      // PayStatus_PayStatusSuccess       PayStatus = 2 // 支付成功
      // PayStatus_PayStatusFail          PayStatus = 3 // 支付失败
      // PayStatus_PayStatusExpire        PayStatus = 4 // 过期
      // PayStatus_PayStatusRefunding     PayStatus = 5 // 退款中
      // PayStatus_PayStatusRefundSuccess PayStatus = 6 // 退款成功
      // PayStatus_PayStatusRefundFail    PayStatus = 7 // 退款失败
      // PayStatus_PayStatusNoNeedPay     PayStatus = 8 //无需支付

      if (!this.orderNo) return;
      getOrderDetail({
        orderNo: this.orderNo
      }).then(res => {
        if (!res.code) {
          let curTimer = new Date().getTime();
          let timerDiff = Math.floor((curTimer - this.lastTimer) / 1000); //单位秒
          if (
            res.data.info.payStatus == "PayStatusSuccess" &&
            res.data.info.orderStatus == "OrderStatusCompleted"
          ) {
            clearInterval(this.orderInfoTimer);
            this.orderInfoTimer = null;
            this.refreshBasicInfo(); //更新详情及列表锁定状态
            this.$message.success("支付成功");

            this.closePayDialog();
          } else if (timerDiff > 300) {
            // 弹窗展示超5分钟后，关闭支付弹窗
            clearInterval(this.orderInfoTimer);
            this.orderInfoTimer = null;
            this.lastTimer = 0;
            this.$message.warning("订单超时，请重新点击购买");

            this.closePayDialog();
          }
        } else {
          if (res.code == 400008) {
            clearInterval(this.orderInfoTimer);
            this.orderInfoTimer = null;
            this.lastTimer = 0;
            this.$message.warning("获取订单详情失败，请重新点击购买");
            this.closePayDialog();
          }
          // this.$message.warning("订单详情获取失败");
          // this.$router.push("/");
        }
      });
    }
  },
  created() {},
  mounted() {
    document.body.style.overflow = "hidden";

    this.initData();
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.conPay {
  position: fixed;
  top: 0;
  height: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;

  .mainArea {
    width: 334px;
    height: 385px;
    border-radius: 16px;
    background: #f7f7f7;

    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin-top: 42px;
      color: #262626;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
    }

    .payCode {
      width: 240px;
      height: 240px;
      margin-top: 9px;

      // box-sizing: border-box;
      // border: 1px solid #ae3510;

      .initCodeStyle {
        width: 100%;
        height: 100%;

        background-image: url("../../assets/images/code/code0.png");
        background-size: cover;

        display: flex;
        align-items: center;
        justify-content: center;

        .loader {
          font-size: 10px;
          width: 1em;
          height: 1em;
          border-radius: 50%;
          text-indent: -9999em;
          animation: mulShdSpin 1.1s infinite ease;
          transform: translateZ(0);
        }
        @keyframes mulShdSpin {
          0%,
          100% {
            box-shadow:
              0em -2.6em 0em 0em #000000,
              1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2),
              2.5em 0em 0 0em rgba(0, 0, 0, 0.2),
              1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2),
              0em 2.5em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2),
              -2.6em 0em 0 0em rgba(0, 0, 0, 0.5),
              -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.7);
          }
          12.5% {
            box-shadow:
              0em -2.6em 0em 0em rgba(0, 0, 0, 0.7),
              1.8em -1.8em 0 0em #000000,
              2.5em 0em 0 0em rgba(0, 0, 0, 0.2),
              1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2),
              0em 2.5em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2),
              -2.6em 0em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.5);
          }
          25% {
            box-shadow:
              0em -2.6em 0em 0em rgba(0, 0, 0, 0.5),
              1.8em -1.8em 0 0em rgba(0, 0, 0, 0.7),
              2.5em 0em 0 0em #000000,
              1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2),
              0em 2.5em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2),
              -2.6em 0em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);
          }
          37.5% {
            box-shadow:
              0em -2.6em 0em 0em rgba(0, 0, 0, 0.2),
              1.8em -1.8em 0 0em rgba(0, 0, 0, 0.5),
              2.5em 0em 0 0em rgba(0, 0, 0, 0.7),
              1.75em 1.75em 0 0em #000000,
              0em 2.5em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2),
              -2.6em 0em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);
          }
          50% {
            box-shadow:
              0em -2.6em 0em 0em rgba(0, 0, 0, 0.2),
              1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2),
              2.5em 0em 0 0em rgba(0, 0, 0, 0.5),
              1.75em 1.75em 0 0em rgba(0, 0, 0, 0.7),
              0em 2.5em 0 0em #000000,
              -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.2),
              -2.6em 0em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);
          }
          62.5% {
            box-shadow:
              0em -2.6em 0em 0em rgba(0, 0, 0, 0.2),
              1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2),
              2.5em 0em 0 0em rgba(0, 0, 0, 0.2),
              1.75em 1.75em 0 0em rgba(0, 0, 0, 0.5),
              0em 2.5em 0 0em rgba(0, 0, 0, 0.7),
              -1.8em 1.8em 0 0em #000000,
              -2.6em 0em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);
          }
          75% {
            box-shadow:
              0em -2.6em 0em 0em rgba(0, 0, 0, 0.2),
              1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2),
              2.5em 0em 0 0em rgba(0, 0, 0, 0.2),
              1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2),
              0em 2.5em 0 0em rgba(0, 0, 0, 0.5),
              -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.7),
              -2.6em 0em 0 0em #000000,
              -1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2);
          }
          87.5% {
            box-shadow:
              0em -2.6em 0em 0em rgba(0, 0, 0, 0.2),
              1.8em -1.8em 0 0em rgba(0, 0, 0, 0.2),
              2.5em 0em 0 0em rgba(0, 0, 0, 0.2),
              1.75em 1.75em 0 0em rgba(0, 0, 0, 0.2),
              0em 2.5em 0 0em rgba(0, 0, 0, 0.2),
              -1.8em 1.8em 0 0em rgba(0, 0, 0, 0.5),
              -2.6em 0em 0 0em rgba(0, 0, 0, 0.7),
              -1.8em -1.8em 0 0em #000000;
          }
        }
      }

      position: relative;
      // overflow: hidden;

      .qrPos {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .close {
        cursor: pointer;
        width: 24px;
        height: 24px;

        position: absolute;
        top: -68px;
        right: -33px;
      }
    }

    .useWx {
      color: #4d4d4d;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      margin-top: 17px;

      display: flex;
      align-items: center;
      justify-content: center;
      .wxCode {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
